import { RatingDisplay } from "@faire/retailer-visitor-shared/components/RatingStars/RatingDisplay";
import { Row } from "@faire/web--source/slate/Layout";
import React from "react";

interface IProps {
  rating: number;
}

export const BrandOverallRating: React.FC<IProps> = (props) => {
  return (
    <Row align="center">
      <RatingDisplay rating={props.rating} />
    </Row>
  );
};
